// src/services/ManualPresenceService.js
//
// Entries and exits an admin records by hand, for the days somebody forgot to
// badge out or forgot the card. They go into the same presence log as door
// taps and count the same in every report, but they are marked: source is
// "manual", entered_by is the admin, note is the reason. Admin only.

import apiClient from './apiClient'

// The backend answers a bad entry with 400 and a message that says what was
// wrong ("time cannot be in the future"). axios turns any 4xx into a thrown
// error whose own message is just the status code, so the body is read from
// the error and the admin sees the reason rather than "400".
async function post(path, body, fallback) {
  let response
  try {
    response = await apiClient.post(path, body)
  } catch (err) {
    throw new Error(err.response?.data?.message ?? err.message ?? fallback)
  }
  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? fallback)
  }
  return response.data
}

/** Recent manual entries, newest first. Times are the office's local time. */
export async function getManualEntries(days = 30) {
  const data = await post('/GetManualPresence', { days }, 'Could not read manual entries')
  return data.entries ?? []
}

/**
 * Record an entry or exit.
 * time is "YYYY-MM-DDTHH:MM" in the office's local time; the backend
 * converts it and refuses anything in the future.
 */
export async function addManualEntry({ entraObjectId, displayName, countryCode, officeName, direction, time, note }) {
  const data = await post('/AddManualPresence', {
    entra_object_id: entraObjectId,
    display_name: displayName ?? '',
    country_code: countryCode,
    office_name: officeName,
    direction,
    time,
    note: note ?? ''
  }, 'Could not record the entry')
  return data.id
}

export async function updateManualEntry({ id, countryCode, officeName, direction, time, note }) {
  await post('/UpdateManualPresence', {
    id,
    country_code: countryCode,
    office_name: officeName,
    direction,
    time,
    note: note ?? ''
  }, 'Could not update the entry')
}

export async function deleteManualEntry(id) {
  await post('/DeleteManualPresence', { id }, 'Could not delete the entry')
}
